import { render, staticRenderFns } from "./delivery_dialog.vue?vue&type=template&id=dce1b46e"
import script from "./delivery_dialog.vue?vue&type=script&lang=js"
export * from "./delivery_dialog.vue?vue&type=script&lang=js"
import style0 from "./delivery_dialog.vue?vue&type=style&index=0&id=dce1b46e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports